import { useLocale } from '../LocaleContext'
import {
  formatDate,
  formatRelativeTime,
  formatShortDate,
  formatLongDate,
  formatDateTime,
  formatNumber,
  formatCompactNumber,
  formatPercentage,
} from '../formatters'

/** Dates and numbers in the reader's language. Money is `useMoney` (U4). */
export function useFormatters() {
  const { currentLocale } = useLocale()
  const locale = currentLocale

  return {
    formatDate: (date: Date | string, formatStr: string) => 
      formatDate(date, formatStr, locale),
    
    formatRelativeTime: (date: Date | string) => 
      formatRelativeTime(date, locale),
    
    formatShortDate: (date: Date | string) => 
      formatShortDate(date, locale),
    
    formatLongDate: (date: Date | string) => 
      formatLongDate(date, locale),
    
    formatDateTime: (date: Date | string) => 
      formatDateTime(date, locale),
    
    formatNumber: (value: number, options?: Intl.NumberFormatOptions) => 
      formatNumber(value, locale, options),
    
    formatCompactNumber: (value: number) => 
      formatCompactNumber(value, locale),
    
    formatPercentage: (value: number) => 
      formatPercentage(value, locale),
  }
}
